var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../../../services/localStorage";
import { hasPermission } from "../../../services/getNavigationPages";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { INSURANCES_CATALOG_LIMIT, INSURANCES_DEFAULT_LIMIT, INSURANCES_DELETE_SUCCESS, INSURANCES_DELETING_TEXT, INSURANCES_LOADING_TEXT, INSURANCES_ROUTE_CREATE, insurancesRouteDetail, insurancesRouteEdit, insurancesRoutePlans, MENU_OPTION_DELETE, MENU_OPTION_EDIT, MENU_OPTION_PLANS, } from "../constants/insurances.constants";
import { useDeleteInsuranceProduct } from "./useDeleteInsuranceProduct";
import { useGetInsuranceProjects } from "./useGetInsuranceProjects";
import { useGetInsuranceSponsors } from "./useGetInsuranceSponsors";
import { useGetInsuranceTypes } from "./useGetInsuranceTypes";
import { useInsurancesErrorHandling } from "./useInsurancesErrorHandling";
var lsLogin = new LocalStorageService("assurehub");
var EMPTY_FILTERS = { projectType: [], sponsorId: [] };
var HIDDEN_TOAST = {
    show: false,
    message: "",
    type: typeAlert.success,
};
var EMPTY_CARD = { id: "", title: "" };
export var useInsurances = function () {
    var navigate = useNavigate();
    var clientId = useState(function () { return lsLogin.getUserLoginStored().clientId; })[0];
    var _a = useState(1), insurancePage = _a[0], setInsurancePage = _a[1];
    var _b = useState(INSURANCES_DEFAULT_LIMIT), insuranceLimit = _b[0], setInsuranceLimit = _b[1];
    var _c = useState(""), nameSearch = _c[0], setNameSearch = _c[1];
    var _d = useState(EMPTY_FILTERS), filters = _d[0], setFilters = _d[1];
    var _e = useState(false), openModalConfirmDelete = _e[0], setOpenModalConfirmDelete = _e[1];
    var _f = useState(EMPTY_CARD), itemCard = _f[0], setItemCard = _f[1];
    var _g = useState(HIDDEN_TOAST), seeToast = _g[0], setSeeToast = _g[1];
    var _h = useState(HIDDEN_TOAST), seeToastSuccess = _h[0], setSeeToastSuccess = _h[1];
    var permissions = {
        create: hasPermission("admin-product-create"),
        read: hasPermission("admin-product-view"),
        update: hasPermission("admin-product-edit"),
        delete: hasPermission("admin-product-delete"),
        detail: true,
    };
    var menuOptions = [
        {
            disabled: !permissions.detail,
            id: "1",
            name: MENU_OPTION_PLANS,
            divider: false,
        },
        {
            disabled: !permissions.update,
            id: "2",
            name: MENU_OPTION_EDIT,
            divider: false,
        },
        {
            disabled: !permissions.delete,
            id: "3",
            name: MENU_OPTION_DELETE,
            color: "red",
            divider: false,
        },
    ];
    var _j = useGetInsuranceSponsors(), fetchSponsors = _j.fetchSponsors, sponsors = _j.sponsors, errorSponsors = _j.errorSponsors, loadingSponsors = _j.loadingSponsors;
    var _k = useGetInsuranceTypes(), fetchInsuranceTypes = _k.fetchInsuranceTypes, insuranceTypes = _k.insuranceTypes, errorInsuranceTypes = _k.errorInsuranceTypes;
    var _l = useGetInsuranceProjects(), fetchProjects = _l.fetchProjects, projects = _l.projects, totalItems = _l.totalItems, loadingProjects = _l.loadingProjects, errorProjects = _l.errorProjects;
    var _m = useDeleteInsuranceProduct(), deleteProduct = _m.deleteProduct, productDeleted = _m.productDeleted, loadingDelete = _m.loadingDelete, errorDelete = _m.errorDelete, clearDelete = _m.clearDelete;
    var sponsorOptions = useMemo(function () {
        return (sponsors !== null && sponsors !== void 0 ? sponsors : [])
            .filter(function (item) { return item.id && item.name; })
            .map(function (item) { return ({ id: item.id, name: item.name, active: false }); });
    }, [sponsors]);
    var insuranceTypeOptions = useMemo(function () {
        return (insuranceTypes !== null && insuranceTypes !== void 0 ? insuranceTypes : [])
            .filter(function (item) { return item.id && item.description; })
            .map(function (item) { return ({
            id: item.id,
            name: item.description,
            active: false,
        }); });
    }, [insuranceTypes]);
    var allSponsorIds = useMemo(function () { return (sponsors !== null && sponsors !== void 0 ? sponsors : []).map(function (item) { return item.id; }); }, [sponsors]);
    var insurancesList = useMemo(function () {
        return (projects !== null && projects !== void 0 ? projects : []).map(function (_a) {
            var campaign = _a.campaign, project = __rest(_a, ["campaign"]);
            return (__assign(__assign({}, project), { id: project.id, title: project.description, logoUrl: project.logoUrl }));
        });
    }, [projects]);
    var loadProjects = function () {
        if (allSponsorIds.length === 0)
            return;
        fetchProjects({
            enable: true,
            page: insurancePage,
            limit: insuranceLimit,
            projectType: filters.projectType,
            sponsorId: filters.sponsorId.length > 0 ? filters.sponsorId : allSponsorIds,
            description: nameSearch,
        });
    };
    useEffect(function () {
        var params = {
            enable: true,
            page: 1,
            limit: INSURANCES_CATALOG_LIMIT,
            clientId: clientId,
        };
        fetchSponsors(params);
        fetchInsuranceTypes(params);
    }, []);
    useEffect(function () {
        loadProjects();
    }, [allSponsorIds, insurancePage, insuranceLimit, filters, nameSearch]);
    useInsurancesErrorHandling({
        errorProjects: errorProjects,
        errorSponsors: errorSponsors,
        errorInsuranceTypes: errorInsuranceTypes,
        errorDelete: errorDelete,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        if (!productDeleted)
            return;
        showToastSuccessMessage(INSURANCES_DELETE_SUCCESS, typeAlert.success, setSeeToastSuccess);
        loadProjects();
        clearDelete();
    }, [productDeleted]);
    var filterStatus = function (item) {
        var _a, _b, _c, _d;
        if (allSponsorIds.length === 0)
            return;
        setFilters({
            projectType: (_b = (_a = item === null || item === void 0 ? void 0 : item.insurance) === null || _a === void 0 ? void 0 : _a.map(function (type) { return type.id; })) !== null && _b !== void 0 ? _b : [],
            sponsorId: (_d = (_c = item === null || item === void 0 ? void 0 : item.sponsor) === null || _c === void 0 ? void 0 : _c.map(function (sponsor) { return sponsor.id; })) !== null && _d !== void 0 ? _d : [],
        });
    };
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
    };
    var handleDelete = function (item) {
        var _a, _b;
        if (!item)
            return;
        setOpenModalConfirmDelete(false);
        var campaign = (_b = (_a = projects === null || projects === void 0 ? void 0 : projects.find(function (project) { return project.id === item.id; })) === null || _a === void 0 ? void 0 : _a.campaign) === null || _b === void 0 ? void 0 : _b[0];
        var hasCampaign = !!campaign && Object.keys(campaign).length > 0;
        deleteProduct({
            projectId: item.id,
            campaignId: hasCampaign ? campaign.id : undefined,
            userId: clientId,
        });
    };
    var optionProduct = function (option, product) {
        switch (option.id) {
            case "1":
                navigate(insurancesRoutePlans(product.id));
                break;
            case "2":
                navigate(insurancesRouteEdit(product.id));
                break;
            case "3":
                setOpenModalConfirmDelete(true);
                setItemCard(product);
                break;
        }
    };
    var seeDetailsProduct = function (item) {
        navigate(insurancesRouteDetail(item.id));
    };
    var productCreation = function () {
        navigate(INSURANCES_ROUTE_CREATE);
    };
    return {
        loading: loadingSponsors || loadingProjects || loadingDelete,
        loadingText: loadingDelete
            ? INSURANCES_DELETING_TEXT
            : INSURANCES_LOADING_TEXT,
        seeToast: seeToast,
        seeToastSuccess: seeToastSuccess,
        closeToast: function () { return setSeeToast(HIDDEN_TOAST); },
        closeToastSuccess: function () { return setSeeToastSuccess(HIDDEN_TOAST); },
        view: {
            permissions: permissions,
            menuOptions: menuOptions,
            insurancesList: insurancesList,
            insuranceTypeOptions: insuranceTypeOptions,
            sponsorOptions: sponsorOptions,
            openModalConfirmDelete: openModalConfirmDelete,
            setOpenModalConfirmDelete: setOpenModalConfirmDelete,
            itemCard: itemCard,
            onClickDelete: handleDelete,
            optionProduct: optionProduct,
            onClickDetails: seeDetailsProduct,
            onClickAdd: productCreation,
            filterStatus: filterStatus,
            searchFilter: searchFilter,
            onCloseSearch: onCloseSearch,
            insurancePage: insurancePage,
            insuranceLimit: insuranceLimit,
            countPagination: totalItems,
            onChangePage: setInsurancePage,
            onChangeRowsPerPage: setInsuranceLimit,
        },
    };
};
